import { Navigate, RouteObject } from "react-router-dom";
import DashboardLayout from "layout/dashboard";
import NotFoundPage, { notFoundRouteName } from "modules/not-found/index.page";
import ListProfilePage, { listProfilePageRouteName } from "modules/list-profile/index.page";
import ProfilePage, { profilePageRouteName } from "modules/profile/features/create/index.page";
import ColorsPage, { colorsPageRouteName } from "modules/design-system/colors/index.page";
import TypographyPage, { typographyPageRouteName } from "modules/design-system/typography/index.page";
import ButtonPage, { buttonPageRouteName } from "modules/design-system/button/index.page";
import FormFieldPage, { formFieldPageRouteName } from "modules/design-system/form-field/index.page";
import IconPage, { iconPageRouteName } from "modules/design-system/icon/index.page";
import TablesPage, { tablesPageRouteName } from "modules/design-system/tables/index.page";
import TranslationPage, { translationPageRouteName } from "modules/design-system/translation/index.page";

// Master Data
import VehicleAuxiliaryPage, { vehicleAuxiliaryPageRouteName } from "modules/master-data/vehicle-auxiliary/list/index.page";
import AddVehicleAuxiliaryPage, { addVehicleAuxiliaryPageRouteName } from "modules/master-data/vehicle-auxiliary/add/add.page";
import EditVehicleAuxiliaryPage, { editVehicleAuxiliaryPageRouteName } from "modules/master-data/vehicle-auxiliary/edit/edit.page";
import LoAPage, { loaPageRouteName } from "modules/master-data/loa/index.page";

import VehicleTypePage, { vehicleTypePageRouteName } from "modules/master-data/vehicle-type/list/index.page";
import AddVehicleTypePage, { addVehicleTypePageRouteName } from "modules/master-data/vehicle-type/add/add.page";
import EditVehicleTypePage, { editVehicleTypePageRouteName } from "modules/master-data/vehicle-type/edit/edit.page";
import DetailVehicleTypePage, { detailVehicleTypePageRouteName } from "modules/master-data/vehicle-type/detail/detail.page";

import FreezerModelPage, { freezerModelPageRouteName } from "modules/master-data/freezer-model/list/index.page";
import AddFreezerModelPage, { addFreezerModelPageRouteName } from "modules/master-data/freezer-model/add/add.page";
import EditFreezerModelPage, { editFreezerModelPageRouteName } from "modules/master-data/freezer-model/edit/edit.page";

import VehicleModelPage, { vehicleModelPageRouteName } from "modules/master-data/vehicle-model/list/index.page";
import AddVehicleModelPage, { addVehicleModelPageRouteName } from "modules/master-data/vehicle-model/add/add.page";
import EditVehicleModelPage, { editVehicleModelPageRouteName } from "modules/master-data/vehicle-model/edit/edit.page";

import VendorPage, { vendorPageRouteName } from "modules/master-data/vendor/index.page";

import AddVendorPage, {
  addVendorPageRouteName,
} from "modules/master-data/vendor/add/add.page";

import EditVendorPage, {
  editVendorPageRouteName,
} from "modules/master-data/vendor/edit/edit.page";

import VendorDetailPage, {
  detailVendorPageRouteName,
} from "modules/master-data/vendor/detail/detail.page";

import DraftVendorPage from "modules/master-data/vendor/draft/index.page";

import DraftEditVendorPage from "modules/master-data/vendor/draft/edit.page";

import {
  FleetPage,
  AddFleetPage,
  EditFleetPage,
  DetailFleetPage,
  fleetPageRouteName,
  addFleetPageRouteName,
  editFleetPageRouteName,
  detailFleetPageRouteName,
} from "modules/master-data/fleet/index.page";
import DraftFleetPage, { draftFleetPageRouteName } from "modules/master-data/fleet/draft/index.page";

import DriverListPage from "modules/master-data/driver/list/index.page";
import AddDriverPage from "modules/master-data/driver/add/add.page";
import EditDriverPage, { editDriverPageRouteName } from "modules/master-data/driver/edit/edit.page";
import DriverDetailPage, { detailDriverPageRouteName } from "modules/master-data/driver/detail/detail.page";
import { driverListPageRouteName, addDriverPageRouteName, draftDriverPageRouteName } from "modules/master-data/driver/constants/routes";
import DraftDriverPage from "modules/master-data/driver/draft/index.page";

// Data Configuration
import FuelTypePage, { fuelTypePageRouteName } from "modules/config/fuel-type/index.page";
import AddFuelTypePage, { addFuelTypePageRouteName } from "modules/config/fuel-type/add/add.page";
import EditFuelTypePage, { editFuelTypePageRouteName } from "modules/config/fuel-type/edit/edit.page";

import TripTypePage, { tripTypePageRouteName } from "modules/config/trip-type/index.page";
import AddTripTypePage, { addTripTypePageRouteName } from "modules/config/trip-type/add/add.page";
import EditTripTypePage, { editTripTypePageRouteName } from "modules/config/trip-type/edit/edit.page";

import DistanceTypePage, { distanceTypePageRouteName } from "modules/config/distance-type/index.page";
import AddDistanceTypePage, { addDistanceTypePageRouteName } from "modules/config/distance-type/add/add.page";
import EditDistanceTypePage, { editDistanceTypePageRouteName } from "modules/config/distance-type/edit/edit.page";

import TripDaysThresholdPage, { tripDaysThresholdPageRouteName } from "modules/config/trip-days-threshold/index.page";
import AddTripDaysThresholdPage, { addTripDaysThresholdPageRouteName } from "modules/config/trip-days-threshold/add/add.page";
import EditTripDaysThresholdPage, { editTripDaysThresholdPageRouteName } from "modules/config/trip-days-threshold/edit/edit.page";

import WaitingTimeRatePage, { waitingTimeRatePageRouteName } from "modules/config/waiting-time-rate/index.page";
import AddWaitingTimeRatePage, { addWaitingTimeRatePageRouteName } from "modules/config/waiting-time-rate/add/add.page";
import EditWaitingTimeRatePage, { editWaitingTimeRatePageRouteName } from "modules/config/waiting-time-rate/edit/edit.page";

// Operation Configuration
import VehicleOperationConfigPage, { vehicleOperationConfigPageRouteName } from "modules/config/vehicle-operation-config/index.page";
import AddVehicleOperationPage, { addVehicleOperationPageRouteName } from "modules/config/vehicle-operation-config/add/add.page";
import EditVehicleOperationPage, { editVehicleOperationPageRouteName } from "modules/config/vehicle-operation-config/edit/edit.page";

import DriverAllowancePage, { driverAllowancePageRouteName } from "modules/config/driver-allowance/index.page";
import AddDriverAllowancePage, { addDriverAllowancePageRouteName } from "modules/config/driver-allowance/add/add.page";
import EditDriverAllowancePage, { editDriverAllowancePageRouteName } from "modules/config/driver-allowance/edit/edit.page";

// DTC
import DriverTripCalculatorPage, { driverTripCalculatorPageRouteName } from "modules/driver-trip-calculator/index.page";

import LoginPage from "modules/login/index.page";
import CustomerPage, { customerPageRouteName } from "modules/master-data/customer/index.page";

import AddCustomerPage from "modules/master-data/customer/add/add.page";
import EditCustomerPage, { editCustomerPageRouteName } from "modules/master-data/customer/edit/edit.page";
import CustomerDetailPage, { detailcustomerPageRouteName } from "modules/master-data/customer/detail/detail.page";
import DraftCustomerPage, { customerDraftPageRouteName } from "modules/master-data/customer/draft/index.page";
import DraftEditCustomerPage, { customerDraftEditPageRouteName } from "modules/master-data/customer/draft/edit.page";
import { addCustomerPageRouteName } from "modules/master-data/customer/constants/routes";

const publicRoutes: Array<RouteObject> = [
  {
    path: "",
    element: <LoginPage />,
  },
  { path: "*", element: <Navigate to="/" /> },
];

const privateRoutes: Array<RouteObject> = [
  {
    path: "",
    element: <DashboardLayout />,
    children: [
      { path: listProfilePageRouteName, element: <ListProfilePage /> },
      { path: profilePageRouteName, element: <ProfilePage /> },
      { path: tablesPageRouteName, element: <TablesPage /> },

      {
        path: "/components",
        children: [
          { path: typographyPageRouteName, element: <TypographyPage /> },
          { path: colorsPageRouteName, element: <ColorsPage /> },
          { path: buttonPageRouteName, element: <ButtonPage /> },
          { path: formFieldPageRouteName, element: <FormFieldPage /> },
          { path: iconPageRouteName, element: <IconPage /> },
          { path: translationPageRouteName, element: <TranslationPage /> },
        ],
      },

      {
        path: "/master-data",
        children: [
          { path: vehicleTypePageRouteName, element: <VehicleTypePage /> },
          { path: addVehicleTypePageRouteName, element: <AddVehicleTypePage /> },
          { path: editVehicleTypePageRouteName(), element: <EditVehicleTypePage /> },
          { path: detailVehicleTypePageRouteName(), element: <DetailVehicleTypePage /> },

          { path: freezerModelPageRouteName, element: <FreezerModelPage /> },
          { path: addFreezerModelPageRouteName, element: <AddFreezerModelPage /> },
          { path: editFreezerModelPageRouteName(), element: <EditFreezerModelPage /> },

          { path: vehicleModelPageRouteName, element: <VehicleModelPage /> },
          { path: addVehicleModelPageRouteName, element: <AddVehicleModelPage /> },
          { path: editVehicleModelPageRouteName(), element: <EditVehicleModelPage /> },

          { path: vendorPageRouteName, element: <VendorPage /> },
          { path: addVendorPageRouteName, element: <AddVendorPage /> },

          { path: editVendorPageRouteName, element: <EditVendorPage /> },
          { path: detailVendorPageRouteName(), element: <VendorDetailPage /> },

          { path: "/master-data/vendor/draft", element: <DraftVendorPage /> },
          { path: "/master-data/vendor/edit/:id", element: <DraftEditVendorPage /> },

          { path: fleetPageRouteName, element: <FleetPage /> },
          { path: `${addFleetPageRouteName}/:draftId?`, element: <AddFleetPage /> },
          { path: editFleetPageRouteName(), element: <EditFleetPage /> },
          { path: detailFleetPageRouteName(), element: <DetailFleetPage /> },
          { path: draftFleetPageRouteName, element: <DraftFleetPage /> },

          { path: driverListPageRouteName, element: <DriverListPage /> },
          { path: `${addDriverPageRouteName}/:draftId?`, element: <AddDriverPage /> },
          { path: detailDriverPageRouteName(), element: <DriverDetailPage /> },
          { path: editDriverPageRouteName(), element: <EditDriverPage /> },
          { path: draftDriverPageRouteName, element: <DraftDriverPage /> },

          { path: vehicleAuxiliaryPageRouteName, element: <VehicleAuxiliaryPage /> },
          { path: addVehicleAuxiliaryPageRouteName, element: <AddVehicleAuxiliaryPage /> },
          { path: editVehicleAuxiliaryPageRouteName(), element: <EditVehicleAuxiliaryPage /> },
          { path: loaPageRouteName, element: <LoAPage /> },
          { path: customerPageRouteName, element: <CustomerPage /> },
          { path: addCustomerPageRouteName, element: <AddCustomerPage /> },

          { path: editCustomerPageRouteName, element: <EditCustomerPage /> },
          { path: detailcustomerPageRouteName(), element: <CustomerDetailPage /> },

          { path: customerDraftPageRouteName, element: <DraftCustomerPage /> },
          { path: customerDraftEditPageRouteName, element: <DraftEditCustomerPage /> },
        ],
      },

      {
        path: "/config",
        children: [
          { path: fuelTypePageRouteName, element: <FuelTypePage /> },
          { path: addFuelTypePageRouteName, element: <AddFuelTypePage /> },
          { path: editFuelTypePageRouteName(), element: <EditFuelTypePage /> },

          { path: tripTypePageRouteName, element: <TripTypePage /> },
          { path: addTripTypePageRouteName, element: <AddTripTypePage /> },
          { path: editTripTypePageRouteName(), element: <EditTripTypePage /> },

          { path: distanceTypePageRouteName, element: <DistanceTypePage /> },
          { path: addDistanceTypePageRouteName, element: <AddDistanceTypePage /> },
          { path: editDistanceTypePageRouteName(), element: <EditDistanceTypePage /> },

          { path: tripDaysThresholdPageRouteName, element: <TripDaysThresholdPage /> },
          { path: addTripDaysThresholdPageRouteName, element: <AddTripDaysThresholdPage /> },
          { path: editTripDaysThresholdPageRouteName(), element: <EditTripDaysThresholdPage /> },

          { path: waitingTimeRatePageRouteName, element: <WaitingTimeRatePage /> },
          { path: addWaitingTimeRatePageRouteName, element: <AddWaitingTimeRatePage /> },
          { path: editWaitingTimeRatePageRouteName(), element: <EditWaitingTimeRatePage /> },

          { path: vehicleOperationConfigPageRouteName, element: <VehicleOperationConfigPage /> },
          { path: addVehicleOperationPageRouteName, element: <AddVehicleOperationPage /> },
          { path: editVehicleOperationPageRouteName(), element: <EditVehicleOperationPage /> },

          { path: driverAllowancePageRouteName, element: <DriverAllowancePage /> },
          { path: addDriverAllowancePageRouteName, element: <AddDriverAllowancePage /> },
          { path: editDriverAllowancePageRouteName(), element: <EditDriverAllowancePage /> },
        ],
      },

      {
        path: "/dtc",
        children: [
          { path: driverTripCalculatorPageRouteName, element: <DriverTripCalculatorPage /> },
        ],
      },

      { path: notFoundRouteName, element: <NotFoundPage /> },
      { path: "*", element: <Navigate to={notFoundRouteName} /> },
    ],
  },
];

export { publicRoutes, privateRoutes };
